// Discovers real Category/Brand filter options for the current collection/search results by
// crawling the actual paginated product list (collection.all_tags/all_vendors proved unreliable
// for large collections -- confirmed live: /collections/all genuinely has ~100 real APR
// products, but "APR" never appeared in a collection.all_tags-driven Brand list, and Category
// was similarly incomplete). Renders them as a single row of dropdown filters (2026-07-15
// redesign, replacing the old sidebar + separate mobile drawer with one responsive bar matching
// xxiituning.com's own `.xxii-facetbar` pattern) into #es-filter-bar
// (snippets/es-filter-bar.liquid). Selecting an option is handled entirely by
// assets/category-brand-filters.js, which listens for change events on
// input[name="es-category"]/[name="es-brand"] by name/value -- it doesn't care where those
// checkboxes physically live, so this file only owns discovery + rendering, never filtering.
(function(){
  const ctx = document.getElementById('es-ctx');
  if (!ctx) return;
  const mode = ctx.getAttribute('data-mode') || 'collection';

  const searchTerms = ctx.getAttribute('data-search-terms') || '';
  const collectionUrl = ctx.getAttribute('data-collection-url') || '';
  const currentTags = (ctx.getAttribute('data-current-tags') || '').split('|').filter(Boolean);
  const totalResults = Number(ctx.getAttribute('data-total-results') || '0');
  const perPage = Number(ctx.getAttribute('data-per-page') || '100');
  const MAX_PAGES = 20; // caps worst-case latency on very large collections/broad queries

  const CATEGORY_LABELS = {
    'bov-diverter': 'Blow Off & Diverter Valves', 'boost-sensors': 'Boost Taps & Sensors',
    'braces-cages': 'Chassis Braces & Cages', 'brakes': 'Brakes, Pads, Rotors & Lines',
    'carbon-fiber': 'Carbon Fiber', 'catch-cans-pcv': 'Catch Cans, Valve Covers & PCV',
    'clutch-flywheels': 'Clutch Kits & Flywheels', 'coilovers-springs': 'Coilovers, Springs & Air Ride',
    'control-arms': 'Control Arms & Bushings', 'ecu-tuning': 'ECUs, Controllers & Tuning',
    'engine-internals': 'Engine Internals', 'engine-mounts': 'Engine & Drivetrain Mounts',
    'exhaust': 'Exhausts, Downpipes & Headers', 'exterior-accessories': 'Exterior Accessories',
    'fueling': 'Fuel Systems, Pumps & Injectors', 'gauges': 'Gauges & Pods',
    'ignition': 'Ignition, Coils & Spark Plugs', 'intakes': 'Intakes, Filters & Inlets',
    'intercoolers': 'Intercoolers & Piping', 'interior-accessories': 'Interior Accessories',
    'lighting': 'Lighting', 'maintenance': 'Maintenance & Service Parts',
    'oil-pans': 'Oil Pans, Shields & Drain Plugs', 'oils-fluids': 'Oils, Fluids & Additives',
    'pulleys': 'Pulleys', 'radiators-cooling': 'Radiators & Cooling',
    'shocks-struts': 'Shocks, Struts & Mounts', 'skirts-splitters-spoilers': 'Skirts, Splitters & Spoilers',
    'sway-bars': 'Sway Bars & End Links', 'throttle-bodies': 'Throttle Bodies & Manifolds',
    'tools-hardware': 'Tools & Hardware', 'transmission-shifters': 'Transmission & Shifters',
    'turbos-superchargers': 'Turbos & Superchargers', 'water-meth-nitrous': 'Water/Meth & Nitrous Systems',
    'wheel-spacers': 'Wheel Spacers & Accessories', 'wheels': 'Wheels',
    'decals-stickers': 'Decals, Stickers & Badges', 'apparel-merch': 'Apparel & Merch',
    'heat-management': 'Heat Management'
  };

  const parser = new DOMParser();

  function pageUrl(page){
    if (mode === 'search') return `/search?q=${encodeURIComponent(searchTerms)}&type=product&page=${page}`;
    const base = currentTags.length ? `${collectionUrl}/${currentTags.map(t => encodeURIComponent(t)).join('+')}` : collectionUrl;
    return `${base}?page=${page}`;
  }

  async function fetchPage(page){
    const res = await fetch(pageUrl(page), { cache: 'no-store' });
    if (!res.ok) return [];
    const doc = parser.parseFromString(await res.text(), 'text/html');
    return Array.from(doc.querySelectorAll('#es-grid .product-item'));
  }

  function collect(items, catCounts, brandCounts){
    items.forEach(item => {
      const tags = (item.getAttribute('data-tags') || '').split(',').filter(Boolean);
      let vendorName = null;
      tags.forEach(t => {
        if (t.indexOf('cat-') === 0) {
          const slug = t.slice(4);
          catCounts.set(slug, (catCounts.get(slug) || 0) + 1);
        } else if (t.indexOf('es-brand-') === 0) {
          if (vendorName === null) {
            const el = item.querySelector('[class*="brand"]');
            vendorName = el ? el.textContent.trim() : null;
          }
          if (vendorName) {
            const key = t.slice(9);
            const existing = brandCounts.get(key);
            brandCounts.set(key, { name: vendorName, count: (existing ? existing.count : 0) + 1 });
          }
        }
      });
    });
  }

  function optionRow(inputName, value, label, count){
    return `<label class="es-fbar__opt"><input type="checkbox" name="${inputName}" value="${value}"><span>${label}</span><small>${count}</small></label>`;
  }

  function dropdown(title, inputName, rows){
    if (!rows.length) return '';
    const optionsHtml = rows.map(r => optionRow(inputName, r.value, r.label, r.count)).join('');
    return `<details class="es-fbar__dd"><summary>${title}<svg class="es-fbar__chev" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></summary><div class="es-fbar__panel">${optionsHtml}</div></details>`;
  }

  function renderInto(container, catCounts, brandCounts){
    const catRows = Array.from(catCounts.keys())
      .filter(s => CATEGORY_LABELS[s])
      .map(s => ({ value: `cat-${s}`, label: CATEGORY_LABELS[s], count: catCounts.get(s) }))
      .sort((a, b) => a.label.localeCompare(b.label));

    const brandRows = Array.from(brandCounts.keys())
      .map(s => ({ value: `es-brand-${s}`, label: brandCounts.get(s).name, count: brandCounts.get(s).count }))
      .sort((a, b) => a.label.localeCompare(b.label));

    container.innerHTML = dropdown('Category', 'es-category', catRows) + dropdown('Brand', 'es-brand', brandRows);

    // Native <details> doesn't close on outside click or when a sibling opens -- wire both up
    // once per render (container is fully replaced above, so listeners never pile up).
    const allDetails = Array.from(container.querySelectorAll('.es-fbar__dd'));
    allDetails.forEach(dd => {
      dd.addEventListener('toggle', () => {
        if (dd.open) {
          allDetails.forEach(other => { if (other !== dd) other.open = false; });
          // Below 768px the panel is `position:fixed` (see es-filter-bar.liquid) so it can't
          // clip off either edge of the screen regardless of which dropdown opened -- but a
          // fixed element has no CSS way to say "just below my own trigger," so set `top` here
          // from the real button position each time one opens.
          if (window.innerWidth < 768) {
            const panel = dd.querySelector('.es-fbar__panel');
            const rect = dd.getBoundingClientRect();
            if (panel) panel.style.top = (rect.bottom + 6) + 'px';
          }
        }
      });
    });
    document.addEventListener('click', e => {
      if (!container.contains(e.target)) allDetails.forEach(dd => { dd.open = false; });
    });
  }

  async function run(){
    if (!totalResults) return;
    const catCounts = new Map();
    const brandCounts = new Map();

    const firstPageItems = await fetchPage(1);
    collect(firstPageItems, catCounts, brandCounts);

    const pagesNeeded = Math.min(Math.ceil(totalResults / perPage), MAX_PAGES);
    if (pagesNeeded > 1) {
      const rest = await Promise.all(
        Array.from({ length: pagesNeeded - 1 }, (_, i) => fetchPage(i + 2))
      );
      rest.forEach(items => collect(items, catCounts, brandCounts));
    }

    const target = document.getElementById('es-filter-bar');
    if (target) renderInto(target, catCounts, brandCounts);
  }

  run();
})();
